var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",style:(_vm.outerStyles)},[_c('v-img',{attrs:{"src":require('@/_static/img/background/logo1.png'),"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }